<template lang="html">
<v-container fluid>
  <router-view />
  <v-row>
    <v-col cols="12" xs="12" sm="4" class="pa-5">
      <h2>Account Status</h2>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12" xs="12" sm="4" class="pa-5">
      <StandardTextCard
        height="700px"
        name="INVITED.user"
        :clickable="false"
      >
        <template #info>
          <!-- As an INVITED.user you can work on projects you have been invited to as well as create your own WORK.packages and Sequences using the Workbench. -->
          <StandardTextfield class="mt-2" color="brown darken-1" textcolor="snow" icon="info" value="See TAKT.projects" :readonly="true" />
          <StandardTextfield class="mt-2" color="brown darken-1" textcolor="snow" icon="info" value="Work in own WORK.packages" :readonly="true" />
          <StandardTextfield class="mt-2" color="brown darken-1" textcolor="snow" icon="info" value="Use TAKT.plan" :readonly="true" />
          <StandardTextfield class="mt-2" color="brown darken-1" textcolor="snow" icon="info" value="Use TAKT.wallet" :readonly="true" />
          <StandardTextfield class="mt-2" color="brown darken-1" textcolor="snow" icon="info" value="Use TAKT.portable" :readonly="true" />
          <StandardTextfield class="mt-2 cursor-pointer" color="brown darken-1" textcolor="snow" icon="info" value="Use TAKT.ing" :readonly="true" />
        </template>
        <template #bottom-info>
          <v-alert width="100%" height="120px" border="top" color="brown darken-1" dark class="mb-10">
            0€ / Month <br>
            No requirements.
          </v-alert>
        </template>
        <template #actions>
          <v-icon :color="hasHigherAccStatusThen('Invited User') ? 'green' : 'grey'">check_circle_outline</v-icon>
        </template>
      </StandardTextCard>
    </v-col>
    <v-col cols="12" xs="12" sm="4" class="pa-5">
      <StandardTextCard
        height="700px"
        name="FULL.user"
        :clickable="false"
      >
      <template #info>
        <!-- As a FULL.user you are enjoying all features of the INVITED.user account. On top of that you are able to create your own projects and invite new as well as existing users to collaborate on them. Further you can contribute to the TAKT.community by uploading your WORK.packages and Sequences. -->
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" value="Create TAKT.projects" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" value="Edit TAKT.projects" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" value="Invite PROJECT.members" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" value="Define PROJECT.roles" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" value="Use PROJECT.statistics" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" value="Use TAKT.journal" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" value="Use TAKT.editor" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" value="Use COMMUNITY.sequences" :readonly="true" />
        <StandardTextfield class="mt-2" color="blue-grey darken-1" textcolor="snow" icon="info" value="Use COMMUNITY.workpackages" :readonly="true" />

      </template>
      <template #bottom-info>
        <v-alert width="100%" height="120px" border="top" color="blue-grey darken-1" dark class="mb-10">
          0€ / Month <br>
          An active running TAKT.project is required.
        </v-alert>
      </template>
      <template #actions>
        <v-btn color="blue" text :disabled="getUser.account_status !== 'Invited User' || getUserUpgrades.id !== -1" :to="{ name: 'AccountSettingsUserUpgradeFullUser'}">Upgrade</v-btn>
        <v-icon :color="hasHigherAccStatusThen('Full User') ? 'green' : 'grey'">check_circle_outline</v-icon>
        <v-icon color="orange" v-if="getUserUpgrades.id !== -1 && getUserUpgrades.requested_role.name === 'Full User'">hourglass_empty</v-icon>
      </template>
      </StandardTextCard>
    </v-col>
    <v-col cols="12" xs="12" sm="4" class="pa-5">
      <StandardTextCard
        height="700px"
        name="PRO.user"
        :clickable="false"
      >
      <template #info>
        <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" value="Use LIVE.projects" :readonly="true" />
        <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" value="Use AUTO.pilots Level 1 + 2" :readonly="true" />
        <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" value="Use projects HISTORY.data" :readonly="true" />
        <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" value="Use projects HISTORY.lap" :readonly="true" />
        <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" value="Use BOOT.camp" :readonly="true" />
        <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" value="Use KICK.start" :readonly="true" />
        <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" value="Use MULTI.projects" :readonly="true" />
        <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" value="Use COMPANY.sequences*" :readonly="true" />
        <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" value="Use COMPANY.workpackages*" :readonly="true" />
        <StandardTextfield class="mt-2" color="amber darken-3" textcolor="snow" icon="info" value="Use COMPANY.projects*" :readonly="true" />
        <!-- As a PRO.user your projects can go live. This means you will experience our AUTO.pilots, PROJECT.history and advanced PROJECT.reports. Further, if you're becoming a Business PRO.user you can share your WORK.packages and Sequences with your colleagues as well as get statistic reports across all your business projects. -->
      </template>
      <template #bottom-info>
        <v-alert width="100%" height="120px" border="top" color="amber darken-3" dark class="mb-10">
          100€ / Month (PRO.account Single) <br>
          1000€ / Month (PRO.account Company) <small>* company only</small> <br>
          1000€ / Month (PRO.account Integration)<br>
          1000€ / Month (PRO.account BI)<br>
        </v-alert>
      </template>
      <template #actions>
        <div class="pro-user-buttons">
          <v-btn color="blue" text
            :disabled="getUser.pro_user_single || getUser.pro_user_company ||  getUserUpgrades.id !== -1"
            :to="{ name: 'AccountSettingsUserUpgradeProUser', params: { type: 'Single'}}">
            Upgrade ({{ $vuetify.breakpoint.mdAndUp ? 'SINGLE' : 'S'}})
          </v-btn>
          <v-btn color="blue" text
            :disabled="getUser.pro_user_company ||  getUserUpgrades.id !== -1"
            :to="{ name: 'AccountSettingsUserUpgradeProUser', params: { type: 'Business'}}">
            Upgrade ({{ $vuetify.breakpoint.mdAndUp ? 'COMPANY' : 'C'}})
          </v-btn>
          <v-btn color="blue" text
            :disabled="getUser.pro_user_integration ||  getUserUpgrades.id !== -1"
            :to="{ name: 'AccountSettingsUserUpgradeProUserIntegration'}">
            Upgrade ({{ $vuetify.breakpoint.mdAndUp ? 'INTEGRATION' : 'I'}})
          </v-btn>
          <v-btn color="blue" text
            :disabled="getUser.pro_user_bi ||  getUserUpgrades.id !== -1"
            :to="{ name: 'AccountSettingsUserUpgradeProUserBI'}">
            Upgrade (BI)
          </v-btn>
          <v-icon :color="hasHigherAccStatusThen('Pro User') ? 'green' : 'grey'">check_circle_outline</v-icon>
          <v-icon color="orange" v-if="showProUserIsRequested()">hourglass_empty</v-icon>
        </div>
      </template>
      </StandardTextCard>
    </v-col>
  </v-row>
  <v-row>
    <v-col xs="12" md="4" class="pa-5">
      <h2>Your Account Status</h2>
    </v-col>
    <v-col xs="12" md="4" class="pa-5">
      <h2>Your Account Password</h2>
    </v-col>
  </v-row>
  <v-row row wrap>
    <v-col xs="12" md="4" class="mb-10 pa-5">
      <v-list>
        <v-subheader>YOUR.roles</v-subheader>
        <v-list-item>
          <v-list-item-icon>
            <v-icon :color="hasHigherAccStatusThen('Invited User') ? 'green' : 'grey'">check_circle_outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>INVITED.user</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon :color="hasHigherAccStatusThen('Full User') ? 'green' : 'grey'">check_circle_outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>FULL.user</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon :color="getUser.pro_user_single ? 'green' : 'grey'">check_circle_outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Pro.user SINGLE</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon :color="getUser.pro_user_company ? 'green' : 'grey'">check_circle_outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Pro.user COMPANY</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon :color="getUser.pro_user_integration ? 'green' : 'grey'">check_circle_outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Pro.user INTEGRATION</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon :color="getUser.pro_user_bi ? 'green' : 'grey'">check_circle_outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Pro.user BI</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-col>
    <v-col cols="12" xs="12" md="4" class="mb-10 pa-5">
      <v-text-field v-model="old_password" filled clear-icon="clear"
      label="Old password" type="password" :rules="[rules.required]">
      </v-text-field>
      <v-text-field v-model="new_password" filled clear-icon="clear"
      label="New password" type="password" :rules="[rules.required, rules.min8, hasNumber, hasSpecialCharacter]">
      </v-text-field>
      {{getAccountSettingsStatus}}
      <br>
      <v-btn :disabled="!passwordIsValid" @click="changePassword(
        {
          id: $store.state.Auth.current_user.id,
          passwords: {
            old_password: old_password,
            new_password: new_password
          }
        }
        )" color="lighten-1">Change Password</v-btn>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import StandardTextCard from '@/components/StandardComponents/StandardTextCard.component.vue'
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue'
import store from '@/store/index'
import {
  mapActions,
  mapGetters
} from 'vuex';
export default {
  name: 'AccountSettings',
  components: {
    StandardTextCard, StandardTextfield
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('User/requestUserUpgrades').then(res => next(res));
  },
  data: function() {
    return {
      old_password: '',
      new_password: '',
      rules: {
        required: value => !!value || 'Required.',
        min8: v => v.length >= 8 || 'Min 8 characters'
      },
    }
  },
  computed: {
    ...mapGetters('View', [
      'getAccountSettingsStatus'
    ]),
    ...mapGetters('Auth', [
      'getUser'
    ]),
    ...mapGetters('User', [
      'getUserUpgrades'
    ]),
    passwordIsValid(){
      if (this.hasSpecialCharacter(this.new_password) & this.hasNumber(this.new_password) & this.new_password.length >= 8) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions('User', [
      'changePassword'
    ]),
    showProUserIsRequested(){
      return this.getUserUpgrades.id !== -1 && (
        this.getUserUpgrades.requested_role.name === 'Pro User' ||
        this.getUserUpgrades.requested_role.name === 'Pro User Integration' ||
        this.getUserUpgrades.requested_role.name === 'Pro User Business' ||
        this.getUserUpgrades.requested_role.name === 'Pro User BI'
      );
    },
    hasNumber(value) {
      var matches = /\d/.test(value);
      if (matches == true) {
        return true;
      } else {
        return 'password has to contain a number.';
      }
    },
    hasSpecialCharacter(value){
      var string = "^ $ * . [ ] { } ( ) ? ! @ # % & : ; | _ ~";
      var format = /[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`]/;
      var matches = format.test(value)
      if (matches == true) {
        return true;
      } else {
        return "password has to contain a special Charakters:" + string;
      }
    },
    hasHigherAccStatusThen(role){
      let curr_role = this.getUser.account_status;
      switch (role) {
        case 'Invited User':
          if (curr_role === 'Invited User' || curr_role === 'Full User' || curr_role === 'Pro User') {
            return true;
          } else {
            return false;
          }
        case 'Full User':
          if (curr_role === 'Full User' || curr_role === 'Pro User') {
            return true;
          } else {
            return false;
          }
        case 'Pro User':
          if (curr_role === 'Pro User') {
            return true;
          } else {
            return false;
          }
        default:
          return false;
      }
    }
  }
}
</script>

<style lang="css" scoped>
.account-checkmark {
  position: absolute;
  right: 5px;
  bottom: 5px;
}
</style>
